module.exports = __webpack_public_path__ + "static/media/image.ac1e8bff.svg";